import { observer } from "mobx-react-lite";
import {
  updateAlarmCode,
  useResponseCenterAlarmCode,
} from "../../../../core/api/responsecenters/alarmcodes";
import { ResponseCenterAlarmCodeDetails } from "../../../../core/api/responsecenters/types";
import useTranslations from "../../../../core/i18n/useTranslations";
import useUser from "../../../../core/user/useUser";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import { AlarmCodeForm } from "./AlarmCodeForm/AlarmCodeForm";
import { notifyApiErrors } from "../../../../core/helpers/helpers";
import { useEffect } from "react";

const EditAlarmCodeModal = ({
  responseCenterId,
  alarmCodeId,
  onClose,
  onEdit,
}: {
  responseCenterId: string | number;
  alarmCodeId: string | number;
  onClose: () => void;
  onEdit: () => void;
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();
  const { data, isLoading, isError } = useResponseCenterAlarmCode(
    responseCenterId,
    alarmCodeId,
  );

  useEffect(() => {
    if (isError) onClose();
  }, [isError]);

  const labels = {
    title: t("AlarmReceptions:alarm_handling_alarm_codes_edit"),
    description: t("AlarmReceptions:alarm_handling_alarm_codes_description"),
    submit: t("Common:save_changes"),
  };

  const onSubmit = async (values: ResponseCenterAlarmCodeDetails) => {
    if (values.forceCallHandling === -1) {
      values.forceCallHandling = undefined;
    }
    try {
      await updateAlarmCode(
        responseCenterId,
        alarmCodeId,
        values,
        authenticatedRequest,
      );

      notify({
        message: t("AlarmReceptions:alarm_handling_alarm_codes_edit_success"),
      });
      onClose();
      onEdit();
    } catch (error) {
      notifyApiErrors(error);
    }
  };

  return (
    <AlarmCodeForm
      isLoading={isLoading}
      isOpen={!!alarmCodeId}
      labels={labels}
      defaultValues={{ ...data }}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
};

export default observer(EditAlarmCodeModal);
